import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import CircularProgress, { CircularProgressProps } from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const UserWaiting = ({ openLoader }: { openLoader: boolean }): ReactElement => {
 const CustomCircularProgress = (props: CircularProgressProps): ReactElement => {
  return (
   <CircularProgress
    variant="indeterminate"
    sx={(theme) => ({
     color: theme.palette.kxLightOrange,
     ...theme.applyStyles("dark", {
      color: theme.palette.kxOrange
     })
    })}
    color={"kxOrange"}
    size={140}
    thickness={8}
    {...props}
   />
  );
 };

 return (
  <Dialog maxWidth={"md"} fullWidth open={openLoader} sx={{ borderRadius: "5px" }}>
   <DialogContent sx={{ p: 2 }}>
    <Stack justifyContent="center" alignItems="center" spacing={2}>
     <Stack>
      <Typography variant="unboundedTitle" fontSize={18}>
       <FormattedMessage id="app.processingRequest" />
      </Typography>
     </Stack>
     <CustomCircularProgress />
     <Stack>
      <Typography variant="subtitle2">
       <FormattedMessage id="app.processingRequest2" />
      </Typography>
     </Stack>
    </Stack>
   </DialogContent>
  </Dialog>
 );
};

export default UserWaiting;
